module.exports = __webpack_public_path__ + "img/back-3-73f7fe07.png";